import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Input } from '@angular/core';
import { CookieService } from '@citi-gcg-173875/citi-utils';


@Injectable()
export class CommonService {
    @Input() compareCardsCookie: any;

    constructor(
        private _cookieService: CookieService,
        @Inject(DOCUMENT) private document: Document) {
    }

    loadStyle(styleName: string) {
        const head = this.document.getElementsByTagName('head')[0];
        const style = this.document.createElement('link');
        style.rel = 'stylesheet';
        style.type = 'text/css';
        style.href = `${styleName}`;

        head.appendChild(style);
    }

    getCookie(cookieName = 'compareCards', original= false) {
        this.compareCardsCookie = this._cookieService.getCookie(cookieName);
        if(original) return JSON.parse(this.compareCardsCookie || '[]');
        if (!!this.compareCardsCookie) {
            // if the cookie exists Parse the cookie by the character |
            const item: Array<string> = this.compareCardsCookie.split('|');
            return item;
        }
        return [];
    }

    updateCookie(cookieName, myCookie, myDate: Date = null) {
        if (!myCookie) { 
          this._cookieService.deleteCookie(cookieName, '/credit-cards', window?.location?.hostname);
          return; 
        }
        if(!myDate){
            myDate = new Date();
            myDate.setMonth(myDate.getMonth() + 1);
        }
        this._cookieService.setCookie({
            name: cookieName,
            value: myCookie,
            expires: myDate,
            path: '/credit-cards'
        });
    }
}
